module.exports = __webpack_public_path__ + "static/media/hifi-04.3b63fe40.png";